import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, Navigation, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { Reveal, Magnetic } from "../lib/motion";
import { WhatsApp, TikTok } from "./Social";
import { CONTACT, NAV } from "../mock";

export default function Footer() {
  return (
    <footer className="relative z-10 bg-[#04140E] text-[#e8e2d4] overflow-hidden">
      <div className="pointer-events-none select-none absolute -bottom-8 left-0 right-0 text-center">
        <span className="font-display font-extrabold text-[24vw] leading-none text-white/[0.03]">TJH</span>
      </div>
      <div className="relative max-w-[1300px] mx-auto px-6 pt-20 pb-10">
        <Reveal>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
              <Logo className="h-14" />
              <p className="mt-6 text-sm leading-relaxed text-[#e8e2d4]/55 max-w-xs">A cozy 3BD/2BA Airbnb with a private pool, spa &amp; endless comfort in the heart of McAllen, Texas. Your day in paradise awaits.</p>
              <div className="flex gap-3 mt-7">
                <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-cursor="hover" aria-label="WhatsApp"
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[var(--moss)] hover:border-[var(--moss)] hover:text-white transition-all"><WhatsApp size={17} /></a>
                <a href={CONTACT.socials.instagram} target="_blank" rel="noreferrer" data-cursor="hover" aria-label="Instagram"
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[var(--moss)] hover:border-[var(--moss)] hover:text-white transition-all"><Instagram size={17} /></a>
                <a href={CONTACT.socials.tiktok} target="_blank" rel="noreferrer" data-cursor="hover" aria-label="TikTok"
                  className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-[var(--moss)] hover:border-[var(--moss)] hover:text-white transition-all"><TikTok size={15} /></a>
              </div>
            </div>
            <div>
              <h4 className="font-body uppercase tracking-[0.2em] text-xs text-[var(--amber)] mb-6">Explore</h4>
              <ul className="space-y-3.5">
                {NAV.map((item) => (
                  <li key={item.to}><Link to={item.to} data-cursor="hover" className="group inline-flex items-center gap-1 text-[15px] text-[#e8e2d4]/70 hover:text-[var(--amber-light)] transition-colors">{item.label}<ArrowUpRight size={14} className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" /></Link></li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="font-body uppercase tracking-[0.2em] text-xs text-[var(--amber)] mb-6">Get In Touch</h4>
              <ul className="space-y-4 text-[15px] text-[#e8e2d4]/70">
                <li className="flex items-start gap-3"><MapPin size={18} className="text-[var(--moss)] mt-0.5 shrink-0" /><span>{CONTACT.address}</span></li>
                <li><a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 hover:text-[var(--amber-light)]"><WhatsApp size={17} className="text-[var(--moss)] shrink-0" /> Message us on WhatsApp</a></li>
                <li><a href={CONTACT.socials.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 hover:text-[var(--amber-light)]"><Instagram size={17} className="text-[var(--moss)] shrink-0" /> @thejacksonhousergv</a></li>
              </ul>
              <div className="flex flex-wrap gap-3 mt-6">
                <Magnetic strength={0.35}>
                  <a href={CONTACT.maps.apple} target="_blank" rel="noreferrer" className="btn-shine inline-flex items-center gap-2 rounded-full sunset-fill text-white font-bold px-5 py-2.5 text-sm"><Navigation size={15} /> Get Directions</a>
                </Magnetic>
                <a href={CONTACT.maps.google} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-white/20 text-[#e8e2d4]/80 hover:border-[var(--moss)] hover:text-white px-4 py-2.5 text-sm transition-colors">Google Maps</a>
              </div>
            </div>
          </div>
        </Reveal>
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#e8e2d4]/40">&copy; {new Date().getFullYear()} The Jackson House RGV. All rights reserved.</p>
          <p className="text-xs text-[#e8e2d4]/40">
            Built by{" "}
            <a
              href="https://smartmediasolutions.io"
              target="_blank"
              rel="noreferrer"
              data-cursor="hover"
              data-testid="footer-smartmedia-link"
              className="font-semibold text-[#e8e2d4]/70 hover:text-[var(--amber-light)] transition-colors"
            >
              Smart Media Solutions
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
